import React from "react";
import { Helmet } from "react-helmet";
import "./maintenance.scss"

const Maintenance = () => {

    return (
        <div className="maintenance">
            <Helmet>
                <title>Seite unter Wartung | Musikkapelle St. Lorenzen</title>
            </Helmet>
            <div className="header">
                <img src="/assets/logo.webp" alt="Logo" />
            </div>
            <div className="container">
            </div>
        </div>
    )
};

export default Maintenance